import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { DefaultLink, useNavigation } from "../../providers/NavigationProvider";
import { FlowActions } from "../../stores/flowStore";
export function useButton(t0) {
  const $ = _c(7);
  const {
    onClick: onClickProp,
    href
  } = t0;
  const {
    renderLink
  } = useNavigation();
  let t1;
  if ($[0] !== href || $[1] !== onClickProp || $[2] !== renderLink) {
    t1 = e => {
      onClickProp?.(e);
      if (href && renderLink !== DefaultLink) {
        FlowActions.endFlow();
      }
    };
    $[0] = href;
    $[1] = onClickProp;
    $[2] = renderLink;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onClick = t1;
  let t2;
  if ($[4] !== onClick || $[5] !== renderLink) {
    t2 = {
      onClick,
      renderLink
    };
    $[4] = onClick;
    $[5] = renderLink;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}